import { render, staticRenderFns } from "./UserPic.vue?vue&type=template&id=4d059091&scoped=true&"
import script from "./UserPic.vue?vue&type=script&lang=js&"
export * from "./UserPic.vue?vue&type=script&lang=js&"
import style0 from "./UserPic.vue?vue&type=style&index=0&id=4d059091&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d059091",
  null
  
)

export default component.exports